export var AnalyticsEventType;
(function (AnalyticsEventType) {
    AnalyticsEventType[AnalyticsEventType["SESSION_START"] = 10] = "SESSION_START";
    AnalyticsEventType[AnalyticsEventType["CONTACT_SUPPORT"] = 11] = "CONTACT_SUPPORT";
    AnalyticsEventType[AnalyticsEventType["TICKET_OPENED"] = 100] = "TICKET_OPENED";
    AnalyticsEventType[AnalyticsEventType["TICKET_SOLVED"] = 110] = "TICKET_SOLVED";
    AnalyticsEventType[AnalyticsEventType["AGENT_REPLY"] = 120] = "AGENT_REPLY";
    AnalyticsEventType[AnalyticsEventType["PAGE_VIEW"] = 150] = "PAGE_VIEW";
    AnalyticsEventType[AnalyticsEventType["HELPFUL"] = 200] = "HELPFUL";
    AnalyticsEventType[AnalyticsEventType["UNHELPFUL"] = 201] = "UNHELPFUL";
    AnalyticsEventType[AnalyticsEventType["VOTE"] = 210] = "VOTE";
    AnalyticsEventType[AnalyticsEventType["UN_VOTE"] = 211] = "UN_VOTE";
    AnalyticsEventType[AnalyticsEventType["FOLLOW"] = 220] = "FOLLOW";
    AnalyticsEventType[AnalyticsEventType["UN_FOLLOW"] = 221] = "UN_FOLLOW";
    AnalyticsEventType[AnalyticsEventType["SEARCH_RESULTS_CLICKED_MORE"] = 310] = "SEARCH_RESULTS_CLICKED_MORE";
    AnalyticsEventType[AnalyticsEventType["SEARCH_RESULTS_IGNORED"] = 320] = "SEARCH_RESULTS_IGNORED";
    AnalyticsEventType[AnalyticsEventType["SEARCH_RESULTS_NONE"] = 330] = "SEARCH_RESULTS_NONE";
    AnalyticsEventType[AnalyticsEventType["SEARCH_RESULTS_ARTICLE_CLICKED"] = 340] = "SEARCH_RESULTS_ARTICLE_CLICKED";
})(AnalyticsEventType || (AnalyticsEventType = {}));
//# sourceMappingURL=analytics-event-type.enum.js.map